import { useEffect } from "react";
import { toast } from "sonner";

const useToastSonner = ({ dependOn }) => {
    useEffect(() => {
        if (!dependOn) {
            toast.dismiss();
            return;
        }
        if (dependOn) {
            toast.loading("Mise à jour ...");
        }
    }, [dependOn]);
};

export default useToastSonner;
